import { Row, Col, Container, Image, Button } from 'react-bootstrap';
import { GiMeal } from "react-icons/gi";
import { FaFemale, FaUserMd } from "react-icons/fa";
import Plate from '../Images/Plate.png';
import chefImage from "../Images/chef-image.png";
import React from 'react';
import { Link } from "react-router-dom";
import './Home.css';
// import video from "../Images/Nutritionist and Dietitian promotional health videos.mp4";

const features = [
    {
        icon: <GiMeal />,
        title: "Personalized Diet Plans",
        description:
            "Customized nutrition plans designed as per your body, lifestyle, and health goals for effective and sustainable results.",
    },
    {
        icon: <FaFemale />,
        title: "PCOS/PCOD Management",
        description:
            "Targeted nutrition strategies to help manage hormonal balance, improve metabolism, and support long-term health.",
    },
    {
        icon: <FaUserMd />,
        title: "1:1 Nutrition Coaching",
        description:
            "Ongoing guidance, support, and accountability to help you stay consistent and achieve your health goals.",
    },
];

function App() {
    return (
        <div className="App">

            {/* === Hero Section === */}

            {/* <div className="hero-wrapper">
        <div className="main position-relative">

          <video
            src={video}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
        </div>
      </div> */}

            {/* This section has the fixed background */}
            <div className="parallax-section  py-5">
                <Row className="align-items-center g-4">

                    {/* Text Section */}
                    <Col lg={6} md={12} className="text-center text-lg-start">
                        <div className="parallax-content">
                            <h1 className="parallax-title">
                                Unlock Your Health Potential
                            </h1>
                            <p className="parallax-subtitle justify-text">
                                Join us on a journey to a healthier and happier you
                            </p>
                        </div>

                    </Col>

                    {/* Image Section */}
                    <Col lg={6} md={12} className="text-center">
                        <Image
                            src={Plate}
                            alt="Healthy plate"
                            fluid
                            className="plate-image"
                        />
                    </Col>
                </Row>
            </div>

            <section className="features-section">
                <Container>
                    <Row className="g-4">
                        <h1 className='image-text text-center'>NUTRINEST</h1>
                        {features.map((item, index) => (
                            <Col lg={4} md={6} sm={12} key={index}>
                                <Link
                                    to="/plans"
                                    className="feature-link"
                                >
                                <div className="feature-card p-4 rounded-4 shadow-lg h-100 text-center">
                                    <div className="feature-icon">{item.icon}</div>

                                    <h3 className="feature-title">
                                        {item.title}
                                    </h3>

                                    <p className="feature-description">
                                        {item.description}
                                    </p>
                                </div>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section className="journey-section">
                <Container>
                    <Row className="align-items-center g-5">

                        {/* Left Image */}
                        <Col lg={4} md={12} className="text-center">
                            <div className="image-wrapper">
                                <Image
                                    src={chefImage}
                                    alt="Healthy lifestyle"
                                    fluid
                                    className="journey-image"
                                />
                            </div>
                        </Col>

                        {/* Right Content */}
                        <Col lg={8} md={12} className="text-center text-lg-start">

                            <h1 className="journey-title">
                                A Journey to Optimal Health
                            </h1>

                            <p className="journey-description justify-text">
                                We believe that good health starts with good nutrition.
                                Our blog is dedicated to providing you with the knowledge
                                and tools you need to make informed food choices and
                                live a healthier lifestyle.
                            </p>

                            <Button to="/blogs" as={Link} variant="outline-success" className="subscribe-btn">
                                Read More
                            </Button>

                        </Col>

                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default App;